/**
 * @param {string} str
 * @param {Record<string, unknown>} data
 */
export default function formatMessage(str, data) {
  return str.replace(/{{([^}]+)}}/, (match, p1) => {
    return data[p1.trim()] || match
  })
}
